import * as React from "react";
import CTAViewState from "./cta-view-state";
//import "./cta-view.css";
// import "./gvp-icons.css";
import { CanvasImage } from "./canvas-image";
import { Pixel } from "./pixel";
import { ExternalStyleNames } from "./external-style-names";
import { pauseIcon, playIcon } from "./constants";
import { Utils } from "./utils";
import { Timecode } from "./time-code";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import { Button } from "@att-bit/duc.components.button-base";
/* DUC Button cyclic Dependencies */
//import { Button } from "@att-bit/duc.components.button"; 

export type CTAViewProps = {
  /**
   *  Data to load video
   */
  data: CTAViewData;
  /**
   *  Events for the CTA
   */
  events?: CTAViewEvents;
  /**
   *  Additional options for CTA View to enable different interfaces like Model etc.
   */
  options?: CTAViewOptions;
  /**
   *  Additional id passed to CTA View
   */
  testId?: string;
};

export type CTAViewData = {
  title: string;
  posterImageUrl: string;
  duration: number;
  seoData: string;
  linkUrl: string[];
  overlayText: string[];
  id: string;
  recommendedVideo?: boolean;
  hoverToggle: boolean;
  chapteredVideo?: any;
  hoverTime?: string[];
  adminDisplay?: string;
};

export type CTAViewOptions = {
  autoPlay?: boolean;
  autoPlayLoop?: boolean;
  autoPlayPause?: boolean;
  overlayTextDisplayAtEnd?: boolean;
  autoPlaySource?: string;
  customClass?: CustomCTAClass;
  customCTAdisplay?: any;
  customCTAStyle?: string;
  customTheme?: string;
  showTime?: boolean;
  showTitle?: boolean;
  startMode?: string;
  videoStyles?: string;
  autoReduceSize?: boolean;
  isPageScroll?: boolean;
  customCTAObject?: CTACustomCTAObject;
  containerWidth?: any;
  roundedCornersClassName?: string;
  unconstrained?: boolean;
  viewportPause?: boolean;
};

export type CTACustomCTAObject = {
  svg_size?: string;
  CTAButtonAlignment?: string;
}

export type CTAViewEvents = {
  handleCTAClick?(): void;
  handleSafariAutoPlay?(): void;
  handlePlayPause(play: boolean);
};

export type CustomCTAClass = {
  cta?: string;
  ctaBackground?: string;
  ctaText?: string;
  ctaButton?: string;
};

export class CTAView extends React.Component<CTAViewProps, CTAViewState> {
    state: CTAViewState;
    private theme: string = "CTAView__ctaThemeDark";
    private autoPlayRef: any;
    private customCss!: CustomCTAClass;
    private stopped!: boolean;
    private updatePoster = false;
    private linkUrlData: any = [];
    private overlayTextData: any = [];
    private player: any;
    private id!: string;
    private timeInSec: any;
    private starHoverTime: any;
    private endHoverTime: any;

    constructor(props: CTAViewProps) {
        super(props);
        this.state = new CTAViewState();
        this.state = {
            ctrlCurrentTime: 0,
            hoverMode: false,
            playing: true,
            useDash: false,
            ctaContainerClassName: '',
            CTAAutoPlayButton: true,
            viewportPauseOption: true,
            ctaImage: true,
        };
        this.autoPlayRef = React.createRef();
        this.updateCustomCssClass = this.updateCustomCssClass.bind(this);
        this.handleOnLoadMetaData = this.handleOnLoadMetaData.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleAmbientClick = this.handleAmbientClick.bind(this);
        this.isInViewport = this.isInViewport.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleCtaBackground = this.handleCtaBackground.bind(this);
        this.updateCustomCssClass(this.props?.options!);
        this.handleOnTimeUpdate = this.handleOnTimeUpdate.bind(this);
        this.handleLoop = this.handleLoop.bind(this);
        this.onMediaLoadError = this.onMediaLoadError.bind(this);
        this.linkUrlEvent();
        this.populateOverlayText();
        this.setId();
    }

    shouldComponentUpdate(nextProp: CTAViewProps) {
        if (nextProp.options !== this.props.options) {
            this.updateCustomCssClass(nextProp?.options!);
        }
        if (nextProp.data.posterImageUrl !== this.props.data.posterImageUrl) {
            this.updatePoster = true;
        } else {
            this.updatePoster = false;
        }
        return true;
    }

    componentDidMount() {
      let CTAAutoPlayButton = true;
      let viewportPauseOption = true;
      if(this.props.options.autoPlay && this.props?.options?.autoPlayPause){
        CTAAutoPlayButton = false
      }
      if(this.props.options?.viewportPause === false){
        viewportPauseOption = false;
      }

      this.setState({CTAAutoPlayButton});
      let ctaContainerClassName = '';
      if(this.props.options.containerWidth  >= 1500 ){
        ctaContainerClassName = 'CTAView__ctaContainer__GT1500';
      } else if(this.props.options.containerWidth  > 800 ){
        ctaContainerClassName = 'CTAView__ctaContainer__GT800';
      }else if(this.props.options.containerWidth  > 500 && this.props.options.containerWidth  <= 800 ){
        ctaContainerClassName = 'CTAView__ctaContainer__GT500__LT800';
      }else if(this.props.options.containerWidth  > 290 && this.props.options.containerWidth  <= 500  ){
        ctaContainerClassName = 'CTAView__ctaContainer__GT290__LT500';
      }else if(this.props.options.containerWidth  > 250 && this.props.options.containerWidth  <= 290  ){
        ctaContainerClassName = 'CTAView__ctaContainer__GT250__LT290';
      }else if(this.props.options.containerWidth  <= 250 ){
        ctaContainerClassName = 'CTAView__ctaContainer__LT250';
      }
      this.setState({ctaContainerClassName, CTAAutoPlayButton, viewportPauseOption});
        this.handleDashScriptLoad();
        this.handleHlsScriptLoad();
        this.handleCtaBackground();
        if(viewportPauseOption) {
          window.addEventListener<'scroll'>('scroll', this.handleScroll);
        }
    if(this.props?.options?.autoPlay && this.autoPlayRef?.current){
      this.autoPlayRef.current.defaultMuted = true;
      this.autoPlayRef.current.muted = true;
      }
    }

    componentWillUnmount() {
      if(this.state.viewportPauseOption) {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }

    componentDidUpdate() {
        if (this.updatePoster) {
            //this.handleCtaBackground();
        }
    }
    handleOnLoadMetaData() {
        if (this.autoPlayRef) {
            this.autoPlayRef.current.volume = 0;
            if (this.state.hoverMode) {
                this.autoPlayRef.current.currentTime = this.starHoverTime;
            }
        }
    }

    setId() {
        const videoTag = document.querySelectorAll('.' + "CTAView__ctaVideo");
        if (videoTag.length > 0) {
            this.id = 'videoPlayer_' + this.props.data.id + '_' + videoTag.length;
        } else {
            this.id = 'videoPlayer_' + this.props.data.id;
        }
    }

    handleHlsScriptLoad() {
        const self = this;
        const HlsUrl = 'https://cdn.jsdelivr.net/npm/hls.js@latest/dist/hls.min.js';
        const hlsScript = document.querySelectorAll('script[src="' + HlsUrl + '"]');
        if (hlsScript.length === 0 && !this.props?.options?.autoPlay) {
            const script = document.createElement('script');
            script.src = HlsUrl;
            script.async = true;
            document.body.appendChild(script);
        }
    }

    onMediaLoadError() {
        this.setState({ useDash: true });
        const self = this;
        setTimeout(() => {
            // @ts-ignore
            if (window.dashjs && self.props?.options?.autoPlay && this.state.useDash) {
                self.buildDashSource();
            } else {
                self.setState({ useDash: false });
            }
        }, 100);
    }

    handleDashScriptLoad() {
        const self = this;
        const dashUrl = 'https://cdn.dashjs.org/v3.1.0/dash.all.min.js';
        const dashScript = document.querySelectorAll('script[src="' + dashUrl + '"]');
        if (dashScript.length === 0 && this.props?.options?.autoPlay) {
            const script = document.createElement('script');
            script.src = dashUrl;
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => {
                if (self.props?.options?.autoPlaySource && this.state.useDash) {
                    self.buildDashSource();
                }
            };
            script.onerror = () => {
                this.setState({ useDash: false });
            };
        } else {
            setTimeout(() => {
                // @ts-ignore
                if (window.dashjs &&
                    self.props?.options?.autoPlay &&
                    this.state.useDash
                ) {
                    self.buildDashSource();
                } else {
                    self.setState({ useDash: false });
                }
            }, 100);
        }
    }

    handleAmbientClick() {
        if (this.props.options && this.props.options.autoPlay && this.autoPlayRef) {
            if (!this.autoPlayRef.current) {
                this.setState({ ctrlCurrentTime: 0 }, () => {
                    this.buildDashSource();
                    if (!this.autoPlayRef.current.playing) {
                        this.autoPlayRef.current.play();
                        this.setState({ playing: true });
                        if (this.props.events && this.props.events.handlePlayPause) {
                          this.props.events.handlePlayPause(true);
                        }
                    }
                });
                return;
            }
            if (!this.autoPlayRef.current.paused) {
                this.autoPlayRef.current.pause();
                this.setState({ playing: false });
                if (this.props.events && this.props.events.handlePlayPause) {
                  this.props.events.handlePlayPause(false);
                }
            } else {
              if(this.state.ctrlCurrentTime >= this.props.data?.duration && this.props.options?.autoPlayLoop === false){
                this.setState({ ctrlCurrentTime: 0 });
              }
                this.autoPlayRef.current.play();
                this.setState({ playing: true });
                if (this.props.events && this.props.events.handlePlayPause) {
                  this.props.events.handlePlayPause(true);
                }
            }
        }
    }

    handleClick() {
        if (this.props.options && this.props.options.autoPlay && this.autoPlayRef) {
            this.autoPlayRef.current.pause();
        }
        if (this.props.events && this.props.events.handleCTAClick) {
            this.props.events?.handleSafariAutoPlay();
            this.props.events.handleCTAClick();
            this.setState({ hoverMode: false });
        }
    }

    handleImageFailure = (event: any) => {
    const posterImage: string = this.props.data.posterImageUrl.replace('_480.jpg', '');
    let newPosterImg: string;
    const breakPoint = Utils.getBreakPoint();
    if (breakPoint === 767) {
      newPosterImg = posterImage + '_400.jpg';
      return;
    } else if (breakPoint === 1024) {
      newPosterImg = posterImage + '_450.jpg';
      return;
    } else {
      newPosterImg = posterImage + '_500.jpg';
    }
      event.target.src = newPosterImg;
      event.onerror = null;
      this.setState({ctaImage: false});
    }
    handleScroll() {
        if (
            this.props.options &&
            this.props.options.autoPlay &&
            !this.stopped &&
            this.state.ctrlCurrentTime <= this.timeInSec
        ) {
            if (this.autoPlayRef) {
                const viewport: boolean = this.isInViewport();
                if (this.autoPlayRef.current.paused && viewport) {
                    this.autoPlayRef.current.play();
                    this.setState({ playing: true });
                    if (this.props.events && this.props.events.handlePlayPause) {
                      this.props.events.handlePlayPause(true);
                    }
                    
                } else if (!this.autoPlayRef.current.paused && !viewport) {
                    this.autoPlayRef.current.pause();
                    this.setState({ playing: false });
                    if (this.props.events && this.props.events.handlePlayPause) {
                      this.props.events.handlePlayPause(false);
                    }
                }
            }
        }
    }

    updateCustomCssClass(options: CTAViewOptions) {
        const customClassProp = options && options.customClass ? options.customClass : {};
        this.customCss = {
            cta: customClassProp.cta || '',
            ctaBackground: customClassProp.ctaBackground || '',
            ctaButton: customClassProp.ctaButton || '',
            ctaText: customClassProp.ctaText || ExternalStyleNames.ctaText || '',
        };
    }

    handleOnTimeUpdate = () => {
      const currentTime = Math.round(this.state.ctrlCurrentTime);
      if(currentTime >= this.props.data?.duration && this.props.options?.autoPlayLoop === false) {
        this.setState({playing: false});
      }
        if(this.props.data.hoverToggle && this.state.hoverMode && (this.state.ctrlCurrentTime > this.endHoverTime)){
          this.setState({ctrlCurrentTime: 0});
          this.autoPlayRef.current.currentTime = this.starHoverTime;
        }else{
          this.setState({ ctrlCurrentTime: this.autoPlayRef?.current?.currentTime });
        }
    };

    handleHover = () => {
        if (this.props.data.hoverToggle) {
            this.setState({ hoverMode: true });
        }
    };

    handleMouseLeave = () => {
        if (this.state.hoverMode && this.props.data.hoverToggle) {
            this.setState({ hoverMode: false });
        } else {
            return;
        }
    };

    handleHoverClick = () => {
        if (this.state.hoverMode && this.props.data.hoverToggle) {
            const { events } = this.props;
            if (events?.handleCTAClick) {
                events?.handleSafariAutoPlay();  
                events.handleCTAClick();
            }
            this.setState({ hoverMode: false });
        } else {
            return;
        }
    };

    handleLoop() {
        if (this.props.options && this.props.options.overlayTextDisplayAtEnd) {
            return false;
        } else if (this.props.data.hoverToggle) {
          return true;
        } else {
            return typeof this.props?.options?.autoPlayLoop !== 'undefined'
                ? this.props.options.autoPlayLoop
                : true;
        }
    }

    getDeviceType = () => {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
          return 'tablet';
      }
      if (
          /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
              ua,
          )
      ) {
          return 'mobile';
      }
      return 'desktop';
    }

    render() {
      const unconstrainedClassName = this.props?.options?.unconstrained === true ? ' unconstrained': '';
      const desktopSmallSize = this.getDeviceType() !== 'desktop' && this.props.options && this.props.options.customCTAStyle ? '' : 'CTADesktopSmall';
        if (this.props.data && this.props.data.hoverTime && this.props.data.hoverToggle) {
            this.starHoverTime = Math.floor(
                Utils.timecodeToSeconds(JSON.parse(this.props.data.hoverTime[0]).b),
            );
            this.endHoverTime = Math.floor(
                Utils.timecodeToSeconds(JSON.parse(this.props.data.hoverTime[0]).e),
            );
        } else {
            this.starHoverTime = 0;
            this.endHoverTime = 10;
        }
        let stylesObj: any = {};
        const imgStylesObj: any = {};
        if (this.props.options && this.props.options.videoStyles) {
            stylesObj = JSON.parse(this.props.options.videoStyles);
        }
        if (this.props.options && this.props.options.autoPlay) {
            //stylesObj[`borderRadius`] = '0px';
            stylesObj[`cursor`] = 'default';
        }
        /* Overlay Styles - not Required*/
        // if (this.overlayTextData.length > 0) {
        //     stylesObj[`alignItems`] = 'flex-start';
        // }
        const time = Timecode.secondsToTimecode(this.props.data.duration);
        if (
            this.props.data &&
            this.props.data.chapteredVideo &&
            this.props.data.chapteredVideo[0]
        ) {
            this.timeInSec = this.props.data.chapteredVideo[0].seconds;
        } else {
            this.timeInSec = Timecode.timecodeToSeconds(time);
        }
        const ariaText = this.props.data.duration
            ? 'Play Video ' +
              this.props.data.title +
              ' Video length is ' +
              Timecode.durationToSpeech(this.props.data.duration)
            : 'Play Video ' + this.props.data.title;
        let ctaTitleStyle;
        let ctaDurationStyle;
        let ctaPlayButtonStyle;
        /*
              // @ts-ignore */
        const ctaStyles =  <style jsx global>{`
          .CTAView__ctaContainer {
            box-sizing: border-box;
            position: relative;
            border-radius: inherit;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1 1 auto;
            -ms-flex: 1 1 auto;
            white-space: normal;
            cursor: pointer;
            text-align: center;
            height: auto;
            width: 100%;
            overflow: hidden;
            -webkit-backface-visibility: hidden;
            -moz-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: translate3d(0, 0, 0);
            -moz-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
          }
          .CTAView__ctaContainer.CTAView__playBtnLight {
          }
          
          .CTAView__fullWidth {
            border-radius: 0 !important;
          }
          
          .CTAView__actionable {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 2;
            left: 0;
            top: 0;
            background: none;
            border: none;
            border-radius: 7px !important;
            cursor: pointer;
          }
          
          .CTAView__ctaBackground {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
          .text-shadow {
            text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.75), 0px 0px 3px rgba(0, 0, 0, 0.95);
          }

        .CTAView__ctaPlayButton:focus {
          outline-style: dotted;
          outline-width: 1px;
          outline-color: inherit;
        }
        
        .CTAView__ctaRecommendedPlayButton {

        }

        .CTAView__ctaRecommendedPlayButton:focus {
          outline-style: dotted;
          outline-width: 1px;
          outline-color: inherit;
        }

          .CTAView__ctaPlayButton,
          .CTAView__ctaRecommendedPlayButton {
            flex: 1 1 auto;
            -ms-flex: 1 1 auto;
            background-color: transparent;
            min-width: 30px;
            fill: #ffffff;
            z-index: 2;
            cursor: pointer;
            position: relative;
            width: 100%;
            height: 100%;
            border: none;
          }
          .CTAView__ctaPlayButton > div,
          .CTAView__ctaRecommendedPlayButton > div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          
          .CTAView__ctaTitle,
          .CTAView__ctaRecommendedTitle {
            flex: 0 0 auto;
            z-index: 2;
            position: relative;
            line-height: normal;
          }
          
          .CTAView__ctaDuration,
          .CTAView__ctaRecommendedDuration {
            flex: 0 0 auto;
            position: relative;
            line-height: normal;
            z-index: 2;
          }
          
          .CTAView__ctaDescription {
            flex: 1 1 auto;
            font-size: 1.92rem;
            max-width: 80rem;
            margin: auto;
            padding: 10px;
            z-index: 2;
            display: none;
          }
          
          /*
          Themes
          */
          /* Dark */
          .CTAView__ctaThemeDark .CTAView__ctaDescription,
          .CTAView__ctaThemeDark .CTAView__ctaDuration,
          .CTAView__ctaRecommendedDuration .CTAView__ctaThemeDark .CTAView__ctaTitle,
          .CTAView__ctaRecommendedTitle {
            text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.75), 0px 0px 3px rgba(0, 0, 0, 0.95);
          }
          
          /* Light */
          .CTAView__ctaBackground .CTAView__ctaThemeLight {
            opacity: 1;
          }
          
          /*
          AutoPlay CTA
          */
          .CTAView__ctaPauseButton {
            z-index: 3;
            cursor: pointer;
            fill: #ffffff;
            background: rgba(0, 0, 0, 0.25);
            width: 25px;
            height: 25px;
            padding: 4px;
            bottom: 10px;
            left: 10px;
            position: absolute;
            opacity: 0.7;
          }
          
          .CTAView__ctaAnimatedDurationBox {
            width: 50px;
            height: 30px;
            background: #1d2329;
            opacity: 0.65;
            bottom: 8px;
            left: 8px;
            z-index: 3;
            fill: #ffffff;
            padding: 2px;
            position: absolute;
            border-radius: 7px;
            justify-content: center;
            cursor: pointer;
            padding-top: 3px;
          }
          .CTAView__ctaAnimatedDurationBox svg {
            height: 25px;
          }
          .CTAView__ctaAnimatedDurationBox:focus {
            outline: 1px dotted;
            outline-color: inherit;
          }
          
          .CTAView__ctaCameraButton {
            width: 25px;
            height: 25px;
            bottom: 0;
            right: 42px;
            position: absolute;
            -webkit-transform: rotateY(180deg);
            -moz-transform: rotateY(180deg);
            -o-transform: rotateY(180deg);
            -ms-transform: rotateY(180deg);
            transform: rotateY(180deg);
          }
          
          .CTAView__ctaPlayRunTimeButton {
            top: 2px;
            right: 26px;
            position: absolute;
            font-size: 20px;
          }
          
          .CTAView__ctaAnimatedDuration {
            right: 6px;
            position: absolute;
            height: 25px;
            font-size: 1.1em;
          }
          
          .CTAView__ctaplay {
            top: 50%;
            left: 50%;
            width: 100%;
            position: absolute;
            transform: translate(-50%, -50%);
          }
          
          @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            .CTAView__ctaplay {
              left: 0px;
            }
            .CTAView__ctaBackground {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              -ms-transform: translate(-50%, -50%);
              height: auto;
              width: 100%;
            }
          }
          
          .CTAView__ctaVideo {
            height: 100%;
            object-fit: cover !important;
            z-index: 1;
            position: absolute;
          }
          
          .CTAView__gvpPlayButton {
            background: 0;
            border: 0;
            width: 8rem;
            height: 8rem;
            padding: 0;
          }
          .CTAView__gvpPlayButton circle {
            opacity: 0.4;
          }
          .CTAView__gvpPlayButton path {
            fill: #fff;
          }
          .CTAView__gvpPlayButton:hover path {
            fill: #009fdb;
          }
          
          .CTAView__topleft,
          .CTAView__lefttop {
            left: 5%;
            top: 10%;
          }
          
          .CTAView__topright,
          .CTAView__righttop {
            right: 5%;
            top: 10%;
          }
          
          .CTAView__topcenter,
          .CTAView__centertop {
            left: 38%;
            top: 10%;
          }
          
          .CTAView__bottomleft,
          .CTAView__leftbottom {
            bottom: 20%;
            left: 5%;
          }
          
          .CTAView__bottomright,
          .CTAView__rightbottom {
            bottom: 10%;
            right: 5%;
          }
          
          .CTAView__bottomcenter,
          .CTAView__centerbottom {
            bottom: 10%;
            left: 38%;
          }
          
          .CTAView__centerleft,
          .CTAView__leftcenter {
            left: 5%;
            bottom: 45%;
          }
          
          .CTAView__centerright,
          .CTAView__rightcenter {
            right: 5%;
            bottom: 45%;
          }
          
          .CTAView__center {
            left: 38%;
            bottom: 45%;
          }
          
          .CTAView__link {
            position: absolute;
            transition: all 0.25s;
            justify-content: center;
            -ms-justify-content: center;
            -ms-flex-pack: center;
            text-align: center;
            box-sizing: content-box;
            align-items: center;
            overflow: hidden;
            border-radius: 0px!important;
            height: 48px;
            line-height: 48px;
            display: inline-flex;
            z-index: 3;
            border: 1px solid transparent;
            font-size: 14px;
            text-decoration: none;
            font-family: "font-medium", "Verdana";
            font-weight: 400;
            width: 200px;
          }
          
          .CTAView__link:hover:after {
            animation: CTAView__arrowAnimationLg 1s ease 0.35s;
          }
          
          .CTAView__linkBlue {
            border-color: #0057b8;
            background-color: #0057b8;
          }
          .CTAView__linkBlue:hover {
            background-color: #007ae2;
            transition: background-color 0.3s linear;
            border-color: #007ae2;
            text-decoration: none;
          }
          
          .CTAView__linkBlack {
            border-color: #1d2329;
            background-color: #1d2329;
          }
          .CTAView__linkBlack:hover {
            text-decoration: none;
            transition: background-color 0.3s linear;
            background-color: #454b52;
            border-color: #454b52;
          }
          
          .CTAView__linkWhite {
            border-color: #fff;
            background-color: #fff;
            color: #1d2329;
          }
          .CTAView__linkWhite:hover {
            text-decoration: none;
            transition: background-color 0.3s linear;
            background-color: #f7f8fa;
            border-color: #f7f8fa;
            color: #1d2329;
          }
          
          .CTAView__text_transparent {
            width: 100%;
            height: 100%;
            display: block;
          }
          
          .CTAView__link_transparent {
            background-color: transparent;
            top: 55px;
            -ms-flex-direction: column;
            flex-direction: column;
            justify-content: center;
            min-height: 0;
            max-height: 100%;
            min-width: 0;
            max-width: 854px;
            position: absolute;
            width: 854px;
            height: 76%;
            align-items: stretch;
          }
          
          .CTAView__overlayTextContainer {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            z-index: 3;
            position: relative;
            text-align: left;
          }
          
          
          .CTAView__overlayContainerlight {
           /* color: #1d2329; */
          }
          
          .CTAView__overlayContentWrapper {
            width: 60%;
          }
          
          .CTAView__overlayContentHeading {
            font-family: font-medium, att_medium, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 48px;
            line-height: 1.2;
            margin: 0px 32px 16px;
          }
          
          .CTAView__overlayContentSubHeading {
            font-family: font-medium, att_medium, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 1;
            text-transform: uppercase;
            margin: 0px 32px 5px;
          }
          
          .CTAView__overlayContent {
            font-family: font-regular, att_regular, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 1.6;
            margin: 15px 32px 8px;
          }
          
          .CTAView__overlayContentLegal {
            font-family: font-regular, att_regular, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 11px;
            line-height: 1.2;
            margin: 16px 32px 8px;
          }
          
          .CTAView__overlayContentCta {
            font-family: font-regular, att_regular, sans-serif;
            font-style: normal;
            font-weight: normal;
            margin: 18px 32px 10px;
            font-size: 14px;
            line-height: 1.2;
            height: 48px;
          }
          .CTAView__overlayContentCta .CTAView__link {
            position: relative;
            width: 200px;
          }
          
          .CTAView__desktopOverlayText {
            display: block;
          }
          
          .CTAView__mobileOverlayText {
            display: none;
          }
          
          .CTAView__durationBoxWrapper {
            width: 100%;
          }
          
          .CTAView__playButtonSvg {
            width: 100px;
            height: 100px;
          }
          
          .CTAView__ctaOverlayWrapper {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .CTAView__ctaOverlayWrapper .CTAView__overlayParentContentWrapper {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: 0;
            width: 47%;
          }
          .CTAView__ctaOverlayWrapper .CTAView__overlayContentWrapper {
            width: 100%;
          }
          
          .CTAView__ctaTitleCustom2019 {
            position: absolute;
            top: 16px;
            left: 16px;
            padding: 5px;
            margin-right: 16px;
            background: rgba(0, 0, 0, 0.6);
          }
          
          .CTAView__ctaDurationCustom2019 {
            position: absolute;
            bottom: 16px;
            right: 16px;
            padding: 5px;
            background: rgba(0, 0, 0, 0.6);
          }
          
          .CTAView__ctaContainer__GT1500 {
            height: 500px;
          }

          .CTAView__ctaContainer__GT1500
            .CTAView__overlayParentContentWrapper {
                left: 8%;
                width: 40%;
            }
          .CTAView__ctaContainer__GT1500 .CTAView__overlayAlignRight {
                    left: 0;
                    width: 47%;
            }

            .CTAView__ctaContainer__GT800 {
              height: 500px;
            }
            .CTAView__ctaContainer__GT800  .CTAView__ctaPlayButton {
                  max-width: 120px !important;
                  max-height: 120px !important;
                  margin: 20px;
                  font-size: 100px;
              }
              .CTAView__ctaContainer__GT800 .CTAView__ctaTitle {
                  font-size: 2em;
              }
              .CTAView__ctaContainer__GT800 .CTAView__ctaDuration {
                  font-size: 2em;
              }
              .CTAView__ctaContainer__GT800 .CTAView__ctaRecommendedPlayButton {
                  max-width: 120px !important;
                  max-height: 120px !important;
                  margin: 20px;
                  font-size: 80px;
              }
              .CTAView__ctaContainer__GT800 .CTAView__ctaRecommendedTitle {
                  font-size: 1.2em;
              }
              .CTAView__ctaContainer__GT800 .CTAView__ctaRecommendedDuration {
                  font-size: 1.2em;
              }
              .CTAView__ctaContainer__GT800 .CTAView__playButtonHover {
                  margin: auto;
              }


              .CTAView__ctaContainer__GT500__LT800 {
                height: 400px;
              }

              .CTAView__ctaContainer__GT500__LT800 .CTAView__ctaPlayButton {
                    max-width: 100px !important;
                    max-height: 100px !important;
                    margin: 10px;
                    font-size: 100px;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__ctaTitle {
                    font-size: 1.4em;
                }
                .CTAView__ctaContainer__GT500__LT800  .CTAView__ctaDuration {
                    font-size: 1.4em;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__ctaRecommendedPlayButton {
                    max-width: 100px !important;
                    max-height: 100px !important;
                    margin: 10px;
                    font-size: 35px;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__ctaRecommendedTitle {
                    font-size: 0.8em;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__ctaRecommendedDuration {
                    font-size: 0.8em;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__link {
                    height: 40px;
                    line-height: 40px;
                    font-size: 11px;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__playButtonSvg {
                    width: 75px;
                    height: 75px;
                }
                .CTAView__ctaContainer__GT500__LT800 .CTAView__playButtonHover {
                    margin: auto;
                }

          
          
          .CTAView__ctaContainer__GT290__LT500 {
            height: 220px;
            justify-content: flex-end;
          }
          .CTAView__ctaContainer__GT290__LT500
            .CTAView__ctaPlayButton {
            max-width: 70px !important;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 70px;
            margin: 0px !important;
          }
          .CTAView__ctaContainer__GT290__LT500 .CTAView__ctaTitle {
            background: rgba(0, 0, 0, 0.5);
            font-size: 1.2em;
            padding: 6px;
            width: 100%;
          }
          .CTAView__ctaContainer__GT290__LT500 .CTAView__ctaDuration {
            background: rgba(0, 0, 0, 0.5);
            font-size: 1.2em;
            padding: 2px 6px 2px 2px;
            width: 100%;
          }
          .CTAView__ctaContainer__GT290__LT500
            .CTAView__ctaRecommendedPlayButton {
            max-width: 70px !important;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 40px;
          }
          .CTAView__ctaContainer__GT290__LT500
            .CTAView__ctaRecommendedTitle {
            background: rgba(0, 0, 0, 0.5);
            font-size: 0.6em;
            padding: 6px;
            width: 100%;
          }
          .CTAView__ctaContainer__GT290__LT500
            .CTAView__ctaRecommendedDuration {
            background: rgba(0, 0, 0, 0.5);
            font-size: 0.6em;
            padding: 2px 6px 2px 2px;
            width: 100%;
          }
          .CTAView__ctaContainer__GT290__LT500 .CTAView__link {
            height: 40px !important;
            line-height: 40px !important;
            font-size: 11px;
          }
          .CTAView__ctaContainer__GT290__LT500 .CTAView__playButtonSvg {
            width: 75px !important;
            height: 75px !important;
          }

          .CTAView__ctaContainer__GT250__LT290 {
            height: 174px;
            justify-content: flex-end;
          }
          .CTAView__ctaContainer__GT250__LT290  .CTAView__ctaPlayButton {
                max-width: 40px !important;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 45px;
                margin: 0px !important;
            }
          .CTAView__ctaContainer__GT250__LT290 .CTAView__ctaTitle {
            background: rgba(0, 0, 0, 0.5);
            font-size: 1.2em;
            padding: 6px;
            width: 100%;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__ctaDuration {
            background: rgba(0, 0, 0, 0.5);
            font-size: 1.2em;
            padding: 2px 6px 2px 2px;
            width: 100%;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__ctaRecommendedPlayButton {
                max-width: 40px !important;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 30px;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__ctaRecommendedTitle {
                display: none;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__ctaRecommendedDuration {
                background: rgba(0, 0, 0, 0.5);
                font-size: 0.5em;
                padding: 2px 6px 2px 2px;
                width: 100%;
                text-align: right;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__CTAView__link {
                display: none;
            }
            .CTAView__ctaContainer__GT250__LT290 .CTAView__playButtonSvg {
                width: 40px !important;
                height: 60px !important;
            }
            
          .CTAView__ctaContainer__LT250 {
            height: 140px;
            justify-content: flex-end;
          }
          .CTAView__ctaContainer__LT250  .CTAView__ctaPlayButton {
                max-width: 40px !important;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 45px;
                margin: 0px !important;
            }
          .CTAView__ctaContainer__LT250 .CTAView__ctaTitle {
                display: none;
            }
            .CTAView__ctaContainer__LT250 .CTAView__ctaDuration {
                background: rgba(0, 0, 0, 0.5);
                font-size: 1em;
                padding: 2px 6px 2px 2px;
                width: 100%;
                text-align: right;
            }
            .CTAView__ctaContainer__LT250 .CTAView__ctaRecommendedPlayButton {
                max-width: 40px !important;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 30px;
            }
            .CTAView__ctaContainer__LT250 .CTAView__ctaRecommendedTitle {
                display: none;
            }
            .CTAView__ctaContainer__LT250 .CTAView__ctaRecommendedDuration {
                background: rgba(0, 0, 0, 0.5);
                font-size: 0.5em;
                padding: 2px 6px 2px 2px;
                width: 100%;
                text-align: right;
            }
            .CTAView__ctaContainer__LT250 .CTAView__CTAView__link {
                display: none;
            }
            .CTAView__ctaContainer__LT250 .CTAView__playButtonSvg {
                width: 40px !important;
                height: 60px !important;
            }



          @media screen and (min-width:1500px) {
            .CTAView__ctaContainer .CTAView__overlayParentContentWrapper {
              left: 8%;
              width: 40%;
            }
            .CTAView__ctaContainer .CTAView__overlayParentContentWrapper.CTAView__overlayAlignRight {
              left: 0;
              width: 47%;
            }
          }
        /*
          .react-playground_previewBox__1dUdo .CTAView__ctaContainer{
            height: 430px!important;
            width: 677px!important;
            justify-content: flex-end;
          }
          
          .composition-card_compositionContainer__3g1C8 .CTAView__ctaContainer{
            height: 390px!important;
            width: 677px!important;
            justify-content: flex-end;
          }
        */

          .CTAView__ctaPlayButton {
            max-width: 120px;
            max-height: 120px;
            margin: 20px;
            font-size: 100px;
            border: none;
        }
        .CTAView__ctaTitle {
            font-size: 2em;
        }
        .CTAView__ctaDuration {
            font-size: 2em;
        }

          @media screen and (max-width: 1024px) and (min-width: 801px) {
            .CTAView__overlayContentHeading {
              font-size: 34px;
            }
            .CTAView__overlayContentSubHeading {
              font-size: 15px;
            }
            .CTAView__overlayContent {
              font-size: 17px;
            }
          }
          
          @media screen and (max-width: 850px) {
            .CTAView__overlayContentWrapper {
              width: 100%;
            }
            .CTAView__desktopOverlayText {
              display: none;
            }
            .CTAView__mobileOverlayText {
              display: block;
              width: 100%;
            }
            .CTAView__overlayTextContainer {
              margin: 30px auto;
            }
            .CTAView__overlayContentHeading {
              font-size: 28px;
              margin-left: 24px;
            }
            .CTAView__overlayContentSubHeading {
              font-size: 12px;
              margin-left: 24px;
            }
            .CTAView__overlayContent {
              font-size: 16px;
              margin-left: 24px;
            }
            .CTAView__overlayContentLegal {
              margin-left: 24px;
            }
            .CTAView__overlayContentCta {
              margin-left: 24px;
            }
          }
          
          @keyframes CTAView__arrowAnimationLg {
            0% {
              background-position: -10px;
            }
            25% {
              background-position: 36px;
            }
            26% {
              background-position: -36px;
            }
            55% {
              background-position: -10px;
            }
          }
          
          `}</style>
              // @ts-ignore */
        const gvpIconsStyles = <style jsx global>{`
        .gvp-icons__gvp-icon {
            font-family: "gvp-icon";
            display: inline-block;
            vertical-align: middle;
            line-height: 1;
            font-weight: normal;
            font-style: normal;
            speak: none;
            text-decoration: inherit;
            text-transform: none;
            text-rendering: auto;
            -moz-osx-font-smoothing: grayscale;
            -webkit-font-smoothing: antialiased;
          }
          
          .gvp-icons__gvp-icon-lg {
            vertical-align: -15%;
            line-height: 0.75em;
            font-size: 1.33333333em;
          }
          
          .gvp-icons__gvp-icon-CameraButton::before {
            content: "\ea01";
          }
          
          .gvp-icons__gvp-icon-Caption::before {
            content: "\ea05";
          }
          
          .gvp-icons__gvp-icon-Close::before {
            content: "\ea02";
          }
          
          .gvp-icons__gvp-icon-ClosePanelButton::before {
            content: "\ea04";
          }
          
          .gvp-icons__gvp-icon-FilterIcon::before {
            content: "\ea03";
          }
          
          .gvp-icons__gvp-icon-FullScreen_collaps::before {
            content: "\ea07";
          }
          
          .gvp-icons__gvp-icon-FullScreen_expand::before {
            content: "\ea06";
          }
          
          .gvp-icons__gvp-icon-LoaderButton::before {
            content: "\ea0b";
          }
          
          .gvp-icons__gvp-icon-PauseButton::before {
            content: "\ea08";
          }
          
          .gvp-icons__gvp-icon-PlayButton::before {
            content: "\ea09";
          }
          
          .gvp-icons__gvp-icon-PrintButton::before {
            content: "\ea0c";
          }
          
          .gvp-icons__gvp-icon-ReplayButton::before {
            content: "\ea0d";
          }
          
          .gvp-icons__gvp-icon-SoundIcon_mute::before {
            content: "\ea0e";
          }
          
          .gvp-icons__gvp-icon-SoundIcon_oneWave::before {
            content: "\ea0f";
          }
          
          .gvp-icons__gvp-icon-SoundIcon_threeWave::before {
            content: "\ea11";
          }
          
          .gvp-icons__gvp-icon-SoundIcon_twoWave::before {
            content: "\ea13";
          }
          
          .gvp-icons__gvp-icon-StarsIcon::before {
            content: "\ea10";
          }
          
          .gvp-icons__gvp-icon-ThumbsDown::before {
            content: "\ea14";
          }
          
          .gvp-icons__gvp-icon-ThumbsUp::before {
            content: "\ea12";
          }
          
          .gvp-icons__gvp-icon-Transcript_collapse::before {
            content: "\ea15";
          }
          
          .gvp-icons__gvp-icon-Transcript_expand::before {
            content: "\ea16";
          }          
        `}</style>
        if (this.props.options && this.props.options.customCTAdisplay) {
            return (
                <>
                <div data-component="gvp-cta" onClick={this.handleClick}>
                    <div data-gvp-cta-custom="true">
                        {this.props.options.customCTAdisplay}
                    </div>
                </div>
                {ctaStyles}
                {gvpIconsStyles}
                </>
            );
        } else if (
            (this.props.options && this.props.options.autoPlay) ||
            this.state.hoverMode
        ) {
            const autoPlayLoop =
                typeof this.props?.options?.autoPlayLoop !== 'undefined'
                    ? this.props.options.autoPlayLoop
                    : true;
            let textAlignRightClass: string = '';
            if (this.overlayTextData && this.overlayTextData.length > 0) {
                textAlignRightClass =
                    this.overlayTextData[0].position === 'right'
                        ? "CTAView__overlayAlignRight"
                        : '';
            }
            /*AutoPlayLoop false, Stopping at first frame
            */
            // if (
            //     Math.round(this.state.ctrlCurrentTime) >= this.timeInSec &&
            //     ((this.props?.data?.overlayText &&
            //         this.props.options &&
            //         this.props.options.overlayTextDisplayAtEnd) ||
            //         (this.props.options && !autoPlayLoop))
            // ) {
            //     this.handleCtaBackground();
            //     return (
            //         <>
            //         {ctaStyles}
            //         {gvpIconsStyles}
            //             <div
            //                 data-component="gvp-cta"
            //                 className={
            //                     "CTAView__ctaContainer bg-black color-white" +
            //                     ' ' + this.state.ctaContainerClassName + ' ' + unconstrainedClassName + ' ' +
            //                     this.theme +
            //                     ' ' +
            //                     this.customCss.cta
            //                 }
            //               //  style={stylesObj}
            //                 ref={(node) => {
            //                   if (node) {
            //                     Object.keys(stylesObj).forEach((item) => {
            //                       let val = stylesObj[item];
            //                       if(item === 'height' || item === 'width'){
            //                         val = val.replace("!important","")  
            //                         node.style.setProperty(item, val, "important");
            //                       }
            //                       else {
            //                         node.style[item] = val;
            //                       }
            //                     })
            //                 }
            //             }}
            //             >
            //                 <img
            //                     src={this.props.data.posterImageUrl}
            //                     className={
            //                         "CTAView__ctaBackground" +
            //                         ' ' +
            //                         this.customCss.ctaBackground
            //                     }
            //                     alt={this.props.data?.adminDisplay}
            //                 />
            //                 {/*<div className={"CTAView__ctaOverlayWrapper"}>
            //                     <div
            //                         className={
            //                             "CTAView__desktopOverlayText" +
            //                             ' ' +
            //                             "CTAView__overlayParentContentWrapper" +
            //                             ' ' +
            //                             textAlignRightClass
            //                         }
            //                     >
            //                         {this.renderOverlaytext(false)}
            //                     </div>
            //                   </div>*/}
            //                 {this.state.CTAAutoPlayButton && this.getDurationBox(true)}
            //             </div>
                        
            //             {/* <div>
            //                 <div className={"CTAView__mobileOverlayText"}>
            //                     {this.renderOverlaytext(true)}
            //                 </div>
            //             </div> */}
            //         </>
            //     );
            // } 
            if (this.props?.options?.autoPlaySource) {
                const sources: any[] = [];
                sources.push(this.props.options.autoPlaySource + '.mp4');
                /* deprecating because of 404 and performance issues */
                //sources.push(this.props.options.autoPlaySource + '.mpd');
                //sources.push(this.props.options.autoPlaySource + '.webm');
                if (
                    this.autoPlayRef &&
                    this.state.hoverMode &&
                    this.props.data.hoverToggle &&
                    this.state.ctrlCurrentTime > this.endHoverTime
                ) {
                    //this.setState({ hoverMode: false });
                    //this.state.ctrlCurrentTime = 0;
                }
                return (
                    <>
                    {ctaStyles}
                    {gvpIconsStyles}
                        <div
                            data-component="gvp-cta"
                            className={`CTAView__ctaContainer ${this.state.ctaContainerClassName} ${unconstrainedClassName} color-white`}
                            //style={stylesObj}
                            ref={(node) => {
                              if (node) {
                                  Object.keys(stylesObj).forEach((item) => {
                                    let val = stylesObj[item];
                                    if(item === 'height' || item === 'width'){
                                      val = val.replace("!important","")  
                                      node.style.setProperty(item, val, "important");
                                    }
                                    else {
                                      node.style[item] = val;
                                    }
                                  })
                              }
                          }}
                            onClick={this.handleHoverClick}
                            onMouseLeave={this.handleMouseLeave}
                        >
                            <video
                                id={this.id}
                                className={"CTAView__ctaVideo" + ' ' + "CTAView__ctaBackground"}
                                //muted={true}
                                onLoadedMetadata={this.handleOnLoadMetaData}
                                loop={this.handleLoop()}
                                playsInline={true}
                                ref={this.autoPlayRef}
                                autoPlay={
                                    this.state.hoverMode || this.props.options.autoPlay
                                }
                                controls={false}
                                onTimeUpdate={this.handleOnTimeUpdate}
                                onError={this.onMediaLoadError}
                                aria-label={`${this.props.data.title} video`}
                            >
                                {(() => {
                                    if (!this.state.useDash) {
                                        return this.getSource(sources);
                                    }
                                })()}
                            </video>
                            {/*this.showOverlayTextOnVideo()*/}
                            {this.state.CTAAutoPlayButton && this.getDurationBox(false)}
                        </div>
                        {/* <div className={"CTAView__mobileOverlayText"}>
                            {this.renderOverlaytext(true)}
                        </div> */}
                    </>
                );
            } else {
                return <><div> autoplay source is required, when autoplay </div>{ctaStyles}{gvpIconsStyles}</>;
            }
        } else {
            ctaTitleStyle =
                this.props?.options?.autoPlay === false
                    ? "CTAView__ctaRecommendedTitle color-white"
                    : "CTAView__ctaTitle color-white";
            ctaDurationStyle =
                this.props?.options?.autoPlay === false
                    ? "CTAView__ctaRecommendedDuration color-white"
                    : "CTAView__ctaDuration color-white";
            ctaPlayButtonStyle =
                this.props?.options?.autoPlay === false
                    ? "CTAView__ctaRecommendedPlayButton"
                    : "CTAView__ctaPlayButton";
            const playBtnTheme =
                this.props?.options?.startMode && this.props.options.startMode === '1'
                    ? 'CTAView__playBtnLight color-black'
                    : '';
            return (
                <>
                {ctaStyles}
                {gvpIconsStyles}
                    <div
                        data-component="gvp-cta"
                        // @ts-ignore: TODO
                        className={`${"CTAView__ctaContainer color-white"} ${this.state.ctaContainerClassName} ${unconstrainedClassName} ${this.theme} ${playBtnTheme} ${this.customCss.cta}`}
                        onClick={this.handleClick}
                        onMouseEnter={this.handleHover}
                       // style={stylesObj}
                       ref={(node) => {
                        if (node) {
                          Object.keys(stylesObj).forEach((item) => {
                            let val = stylesObj[item];
                            if(item === 'height' || item === 'width'){
                              val = val.replace("!important","")  
                              node.style.setProperty(item, val, "important");
                            }
                            else {
                              node.style[item] = val;
                            }
                          })
                      }
                    }}
                    >
                      { this.state.ctaImage &&  
                        <img
                           id={this.props.data.id}
                            src={this.props.data.posterImageUrl}
                            className={
                                "CTAView__ctaBackground" + ' ' + this.customCss.ctaBackground
                            }
                            alt={this.props.data?.adminDisplay}
                            style={imgStylesObj}
                            onError={event => {
                              this.handleImageFailure(event)
                              }}
                        />}
                        {(() => {
                            {/*if (this.overlayTextData.length === 0) { */}
                                let showTime: boolean = false;
                                let showTitle: boolean = false;
                                if (
                                    this.props.options &&
                                    typeof this.props.options.showTitle === 'undefined'
                                ) {
                                    showTitle = true;
                                }
                                if (
                                    this.props.options &&
                                    typeof this.props.options.showTime === 'undefined'
                                ) {
                                    showTime = true;
                                }

                                if (
                                    this.props.options &&
                                    this.props.options.customTheme &&
                                    this.props.options.customTheme === '2019'
                                ) {
                                    ctaTitleStyle = "CTAView__ctaTitleCustom2019";
                                    ctaDurationStyle = "CTAView__ctaDurationCustom2019";
                                }
                                if (
                                    this.props?.options?.showTitle ||
                                    this.props?.options?.showTime
                                ) {
                                    showTitle = this.props.options?.showTitle!;
                                    showTime = this.props.options?.showTime!;
                                    ctaTitleStyle = "CTAView__ctaTitleCustom2019";
                                    ctaDurationStyle = "CTAView__ctaDurationCustom2019";
                                }
                                let gvpSize = IconSvgSizes.XXL;;  
                                if(this.props.options.containerWidth <= 500) {
                                  gvpSize = IconSvgSizes.LG;
                                } else if((this.props.options.containerWidth > 500) && (this.props.options.containerWidth <= 800)){
                                  gvpSize = IconSvgSizes.XL;
                                }

                                let svg_size: any = this.props.options.customCTAObject && this.props.options.customCTAObject?.svg_size ? this.props.options.customCTAObject.svg_size : gvpSize;
                                var mtop = svg_size ? svg_size/2 : parseInt(IconSvgSizes.XXL)/2;
                                //var pos = this.props.options.customCTAStyle ? this.props.options.customCTAStyle : 'center'; 
                                var pos_style = {} ;
                                
                                if(this.props.options && this.props.options.customCTAObject && this.props.options.customCTAObject.CTAButtonAlignment){
                                  const all_classes = ['top_left', 'top', 'top_right', 'center_left', 'center', 'center_right', 'bottom_left', 'bottom', 'bottom_right'];
                                  let class_name = all_classes.includes(this.props.options.customCTAObject.CTAButtonAlignment.toLowerCase()) ? this.props.options.customCTAObject.CTAButtonAlignment.toLowerCase() : 'center'
                                  pos_style = this.getDeviceType() === 'mobile' ? {} : this.getPlayButtonPos(class_name, mtop);
                                }
                               
                                return (
                                    <>
                                        <button
                                            className={
                                                ctaPlayButtonStyle +
                                                ' ' +
                                                this.customCss.ctaButton + ' ' +
                                                desktopSmallSize
                                            }
                                            style={pos_style}
                                            tabIndex={0}
                                            onClick={this.handleClick}
                                        >
                                            {this.getPlayButton(svg_size)}
                                        </button>
                                        {showTitle ? (
                                            <div
                                                className={
                                                    ctaTitleStyle + ' ' + `${(this.props.options.containerWidth <= 500) ? "type-sm " : 'type-lg '}` + " text-shadow radius-sm font-regular" + " " + `${ctaTitleStyle === 'CTAView__ctaTitleCustom2019' ? " bg-gray-900" : '' }` +
                                                    ' ' +
                                                    this.customCss.ctaText
                                                }
                                            >
                                                {this.props.data.title}
                                            </div>
                                        ) : null}
                                        {showTime ? (
                                            <div
                                                className={
                                                    ctaDurationStyle + ' ' + " text-shadow radius-sm font-regular" + " " + `${(this.props.options.containerWidth <= 500) ? "type-sm " : 'type-lg '}` +
                                                    ' ' + `${ctaDurationStyle === 'CTAView__ctaDurationCustom2019' ? "bg-gray-900" : '' }` + ' ' +
                                                    this.customCss.ctaText
                                                }
                                            >
                                                {time}
                                            </div>
                                        ) : null}
                                        <div
                                            className={
                                                "CTAView__ctaDescription" +
                                                ' ' +
                                                this.customCss.ctaText
                                            }
                                        />
                                    </>
                                );
                                
                            {/*}} else { 
                                let textAlignRightClass: string = '';
                                if (
                                    this.overlayTextData &&
                                    this.overlayTextData.length > 0
                                ) {
                                    textAlignRightClass =
                                        this.overlayTextData[0].position === 'right'
                                            ? "CTAView__overlayAlignRight"
                                            : '';
                                }
                                return (
                                    <div className={"CTAView__ctaOverlayWrapper"}>
                                        <div
                                            className={
                                                "CTAView__desktopOverlayText" +
                                                ' ' +
                                                "CTAView__overlayParentContentWrapper" +
                                                ' ' +
                                                textAlignRightClass
                                            }
                                        >
                                            {this.renderOverlaytext(false)}
                                        </div>
                                        <div
                                            className={
                                                ctaPlayButtonStyle +
                                                ' ' +
                                                this.customCss.ctaButton +
                                                ' ' +
                                                "CTAView__mobileOverlayText"
                                            }
                                        >
                                            {this.getPlayButton()}
                                        </div>
                                        <div
                                            className={
                                                ctaPlayButtonStyle +
                                                ' ' +
                                                this.customCss.ctaButton +
                                                ' ' +
                                                "CTAView__desktopOverlayText"
                                            }
                                        >
                                            {this.getPlayButton()}
                                        </div>
                                    </div>
                                );
                            } */}
                        })()}
                        <button
                            report-title={
                                this.props.data.recommendedVideo
                                    ? 'recommended-video'
                                    : ''
                            }
                            recommended-video={
                                this.props.data.recommendedVideo ? this.props.data.id : ''
                            }
                            recommended-friendly-name={
                                this.props.data.recommendedVideo
                                    ? this.props.data.title
                                    : ''
                            }
                            onClick = {this.handleClick}
                            className={"CTAView__actionable" + ' gvp-cta-text type-base'}
                            aria-label={ariaText}
                        />
                        {this.props.data.seoData && (
                            <script type="application/ld+json">
                                {this.props.data.seoData}
                            </script>
                        )}
                    </div>
                    {/* <div className={"CTAView__mobileOverlayText"}>
                        {this.renderOverlaytext(true)}
                    </div> */}
                </>
            );
        }
    }

    showOverlayTextOnVideo() {
        if (
            this.props.data.overlayText &&
            this.props.options &&
            !this.props.options.overlayTextDisplayAtEnd
        ) {
            return (
                <div className={"CTAView__ctaOverlayWrapper"}>
                    <div
                        className={
                            "CTAView__desktopOverlayText" +
                            ' ' +
                            "CTAView__overlayParentContentWrapper"
                        }
                    >
                        {this.renderOverlaytext(false)}
                    </div>
                </div>
            );
        }
    }

    getPlayButton(val=IconSvgSizes.XXL) {
        return <IconSvg size={val} svgNodeStr={playIcon} pictogram={true} altText={'play Button Icon CtaView'}/>;
    }

    buildDashSource() {
        // @ts-ignore
        if (window.MediaSource && window.location.protocol.match('http')) {
            const url = Utils.getStreamingSource(
                this.props?.options?.autoPlaySource,
                'mpd',
            );
            // @ts-ignore
            this.player = window.dashjs.MediaPlayer().create();
            this.player.initialize(document.querySelector('#' + this.id), url, true);
            this.player.on('error', (e: any) => {
                this.setState({ useDash: false });
            });
        } else {
            this.setState({ useDash: false });
        }
    }

    getSource(sources: any[]) {
        const sourcesArr: JSX.Element[] = [];
        if (sources) {
            sources.forEach((source: string | undefined) => {
                sourcesArr.push(<source key={source} type="video/mp4" src={source} />);
            });
        }
        return sourcesArr;
    }

    getDurationBox(isCtaView: boolean) {
      let gvpSize = IconSvgSizes.XXL;  
      if(this.props.options.containerWidth <= 500) {
        gvpSize = IconSvgSizes.LG;
      } else if((this.props.options.containerWidth > 500) && (this.props.options.containerWidth <= 800)){
        gvpSize = IconSvgSizes.XL;
      }
      const svg_size: any = this.props.options.customCTAObject && this.props.options.customCTAObject?.svg_size ? this.props.options.customCTAObject.svg_size : gvpSize;
        if (!(this.state.hoverMode && this.props.data.hoverToggle)) {
            return (
                <>
                    <div className={"CTAView__durationBoxWrapper"}>
                        <div
                            className={"CTAView__ctaAnimatedDurationBox"}
                            onKeyDown={this.handleAmbientClick}
                            tabIndex={0}
                            onClick={this.handleAmbientClick}
                        >
                            <div
                                title={
                                    this.state.playing && !isCtaView
                                        ? 'Video is Playing'
                                        : 'Video is Paused'
                                }
                            >
                                {this.state.playing && !isCtaView ? (
                                    <IconSvg
                                        size={IconSvgSizes.MD}
                                        svgNodeStr={pauseIcon}
                                        altText={'Video is Playing pause Icon'}
                                    />
                                ) : (
                                    <IconSvg
                                        size={IconSvgSizes.MD}
                                        svgNodeStr={playIcon}
                                        altText={'Video is Paused Play Icon'}
                                    />
                                )}
                            </div>
                        </div>
                        {this.props.data.seoData && (
                            <script type="application/ld+json">
                                {this.props.data.seoData}
                            </script>
                        )}
                        {this.getUrl()}
                    </div>
                </>
            );
        } else {
            return (
                <div
                    className={
                        "CTAView__ctaPlayButton" +
                        ' ' +
                        this.customCss.ctaButton +
                        ' ' +
                        "CTAView__playButtonHover"
                    }
                    tabIndex={0}
                >
                    <div
                        className={
                            "gvp-icons__gvp-icon" + ' ' + "gvp-icons__gvp-icon-PlayButtonWithCircle"
                        }
                        style={{ width: '100%' }}
                    >
                    {this.getPlayButton(svg_size)}
                    </div>
                </div>
            );
        }
    }

    getPlayButtonPos(pos, mtop) {
      var btnStyle = {
        'top_left': {
          position:"absolute", top: '0px', left: '0px'
        },
        'top': {
          position:"absolute", top: '0%'
        },
        'top_right': {
          position:"absolute", top: '0px', right: '0px'
        },
        'center_left' : {
          position:"absolute", top: '50%', marginTop: `-${mtop}px `, left: '0px'
        },
        'center' : {
        //  position:"absolute", top: '50%', marginTop: `-${mtop}px `
        },
        'center_right' : {
          position:"absolute", top: '50%', marginTop: `-${mtop}px `, right: '0px'
        },
        'bottom_left' : {
          position:"absolute", top: '100%', marginTop: `-${mtop*2}px `, left: '0px'
        },
        'bottom' : {
          position:"absolute", top: '100%', marginTop: `-${mtop*2}px `
        },
        'bottom_right' : {
          position:"absolute", top: '100%', marginTop: `-${mtop*2}px `, right: '0px'
        },
      }
      const position = pos?.toLowerCase();
      return btnStyle[position]
    }

    linkUrlEvent() {
        if (!this.linkUrlData.length && this.props.data.linkUrl) {
            const urlString = this.props.data.linkUrl;
            if (urlString) {
                if (urlString) {
                    urlString.forEach((url) => {
                        const e = JSON.parse(url);
                        const urlText = e.u;
                        const obj = {
                            begin: Math.floor(Utils.timecodeToSeconds(e.b)),
                            bgColor: e.bc || undefined,
                            end: Math.floor(Utils.timecodeToSeconds(e.e)),
                            link: urlText,
                            position: e.p || undefined,
                            title: e.n || undefined,
                        };
                        this.linkUrlData.push(obj);
                    });
                }
            }
        }
        return this.linkUrlData;
    }

    populateOverlayText() {
        if (!this.overlayTextData.length && this.props.data.overlayText) {
            const overlayTextString = this.props.data.overlayText;
            if (overlayTextString) {
                if (overlayTextString) {
                    overlayTextString.forEach((overlayText) => {
                        const e = JSON.parse(overlayText);
                        const obj = {
                            content: e.c || '',
                            ctaText: e.bt || '',
                            ctaUrl: e.bu || '',
                            heading: e.h || '',
                            legal: e.l || '',
                            position: e.p || '',
                            subheading: e.sh || '',
                            theme: e.t || '',
                        };
                        this.overlayTextData.push(obj);
                    });
                }
            }
        }
        return this.overlayTextData;
    }

    private renderOverlaytext(isMobile: boolean) {
        if (this.overlayTextData && this.overlayTextData.length > 0) {
            const overlayTextData = this.overlayTextData[0];
            const overrideStyleObject = {};
            if (overlayTextData.position) {
                // @ts-ignore: TODO RESOLVE LINTING ERROR
                overrideStyleObject[`alignItems`] =
                    overlayTextData.position === 'left'
                        ? 'flex-start'
                        : overlayTextData.position === 'center'
                        ? 'center'
                        : 'flex-end';
                // @ts-ignore: TODO RESOLVE LINTING ERROR
                overrideStyleObject[`textAlign`] = overlayTextData.position;
            }
            return (
                <div
                    className={
                        "CTAView__overlayTextContainer" +
                        ' ' +
                        (overlayTextData.theme &&
                        overlayTextData.theme.toLowerCase() === 'dark' &&
                        !isMobile
                            ? "color-white"
                            : "CTAView__overlayContainerlight color-black")
                    }
                    style={overrideStyleObject}
                >
                    <div className={"CTAView__overlayContentWrapper"}>
                        <div className={"CTAView__overlayContentSubHeading"}>
                            {overlayTextData.subheading}
                        </div>
                        <div className={"CTAView__overlayContentHeading"}>
                            {overlayTextData.heading}
                        </div>
                        <div
                            className={"CTAView__overlayContent"}
                            dangerouslySetInnerHTML={{ __html: overlayTextData.content }}
                        />
                        <div className={"CTAView__overlayContentLegal"}>
                            {overlayTextData.legal}
                        </div>
                        {overlayTextData.ctaText && overlayTextData.ctaUrl ? (
                            <div className={"CTAView__overlayContentCta"}>
                                {/*<a
                                    className={
                                        "CTAView__link" +
                                        ' btn btn-primary btn-arrow ' +
                                        (overlayTextData.theme &&
                                        overlayTextData.theme.toLowerCase() === 'dark' &&
                                        !isMobile
                                            ? "CTAView__linkWhite" + ' on-dark'
                                            : "CTAView__linkBlack")
                                    }
                                    target="_blank"
                                    report-title="linkUrl"
                                    link-title={overlayTextData.ctaText + ' Link'}
                                    link-url={overlayTextData.ctaUrl}
                                    href={overlayTextData.ctaUrl}
                                    onClick={this.overlayTextLinkClick}
                                    aria-label={`${overlayTextData.ctaText} button will open in new window`}
                                >
                                    {overlayTextData.ctaText}
                                  </a>*/}
                              <div
                                className={
                                  "CTAView__link" +
                                  ' btn btn-primary btn-arrow ' +
                                  (overlayTextData.theme &&
                                  overlayTextData.theme.toLowerCase() === 'dark' &&
                                  !isMobile
                                      ? "CTAView__linkWhite" + ' on-dark'
                                      : "CTAView__linkBlack color-white")
                                  }
                              >
                                <Button
                                  target="_blank"
                                  report-title="linkUrl"
                                  link-title={overlayTextData.ctaText + ' Link'}
                                  link-url={overlayTextData.ctaUrl}
                                  href={overlayTextData.ctaUrl}
                                 >
                                     {overlayTextData.ctaText}
                                </Button>
                              </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            );
        }
    }

    private getUrl() {
        let linkObj;
        let linkPos;
        const data = this.linkUrlData;
        for (const linkValue of data) {
            if (
                this.state.ctrlCurrentTime >= linkValue.begin &&
                this.state.ctrlCurrentTime <= linkValue.end
            ) {
                linkObj = linkValue;
                linkPos = linkObj.position // @ts-ignore: TODO
                    ? linkObj.position
                    : "CTAView__bottomcenter";
                const bColor = linkObj.bgColor.toLowerCase();
                const blueButtonStyle = [
                    "CTAView__link",
                    linkPos,
                    "CTAView__linkBlue",
                    "color-white",
                    'btn',
                    'btn-primary',
                    'btn-arrow',
                ].join(' ');
                const blackButtonStyle = [
                    "CTAView__link",
                    linkPos,
                    "CTAView__linkBlack",
                    "color-white",
                    'btn',
                    'btn-primary',
                    'btn-arrow',
                ].join(' ');
                return (
                    <div key={linkObj.link}>
                        <a
                            className={
                                bColor === 'blue' && linkObj.title
                                    ? blueButtonStyle
                                    : linkObj.title
                                    ? blackButtonStyle
                                    : `${"CTAView__linkTransparent"}  ${"CTAView__textTransparent"}`
                            }
                            target="_blank"
                            href={linkObj.link}
                            aria-label={`${linkObj.title} button will open in new window`}
                        >
                            {linkObj.title}
                        </a>
                    </div>
                );
            }
        }
    }

    private isInViewport(): boolean {
        const el = this.autoPlayRef.current;
        let r: any;
        let html: any;
        if (!el || 1 !== el.nodeType) {
            return false;
        }
        html = document.documentElement;
        r = el.getBoundingClientRect();
        if (this.autoPlayRef) {
            if (
                !!r &&
                r.top >= 0 &&
                r.bottom >= 0 &&
                r.right >= 0 &&
                r.top <= html.clientHeight &&
                r.bottom <= html.clientHeight &&
                r.left <= html.clientWidth
            ) {
                return true;
            } else if ((!!r && r.top >= html.clientHeight) || r.bottom <= 0) {
                return false;
            } else if (
                (!!r && r.top < 0 && r.bottom <= html.clientHeight) ||
                (r.top >= 0 && r.bottom > html.clientHeight)
            ) {
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private handleCtaBackground() {
        if (!this.props.data.posterImageUrl) {
            return;
        }
        const image: CanvasImage = new CanvasImage(this.props.data.posterImageUrl);

        image.loaded(() => {
            const val = image.hasColorsSimilarTo(new Pixel(200, 200, 200), {
                h: 0.66,
                w: 0.66,
                x: 0.33,
                y: 0.33,
            });
            if (val > 0.1) {
                this.theme = "CTAView__ctaThemeDark";
            } else {
                this.theme = "CTAView__ctaThemeLight";
            }
        });
    }

    private overlayTextLinkClick(e: { stopPropagation: () => void }) {
        e.stopPropagation();
        return;
    }
}

export default CTAView;